/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import List from "@ckeditor/ckeditor5-list/src/list";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import { Image } from "@ckeditor/ckeditor5-image";
import MathPlugin from "./MathEQ/mathPlugin.public";

ClassicEditor.create(document.querySelector("#editor"), {
  mathSerial: "PSZAhcmQ7S8jr9V5bIlu",

  plugins: [
    Essentials,
    Paragraph,
    Heading,
    Image,
    List,
    Bold,
    Italic,
    MathPlugin,
  ],

  toolbar: [
    "heading",
    "bold",
    "italic",
    "numberedList",
    "bulletedList",
    "math",
  ],
})
  .then((editor) => {
    console.log("Editor was initialized", editor);
  })
  .catch((error) => {
    console.error(error.stack);
  });
